import {
    getChannelsFailure,
    getChannelsSuccess,
    setNowNextByChannelId,
} from 'store/programs/actions';
import { RequestStatus } from 'store/utils';

import {
    GET_CHANNELS_FAILURE,
    GET_CHANNELS_REQUEST,
    GET_CHANNELS_SUCCESS,
    SET_NOW_NEXT_BY_CHANNEL_ID,
} from './constants';
import { ProgramsState } from './reducer.types';

const programsInitialState: ProgramsState = {
    getChannelsRequest: {
        status: RequestStatus.IDLE,
        error: null,
    },
    channels: undefined,
    nowNextByChannelId: {},
};

const handlers = {
    [GET_CHANNELS_REQUEST](state: ProgramsState): ProgramsState {
        return {
            ...state,
            getChannelsRequest: {
                ...state.getChannelsRequest,
                status: RequestStatus.PENDING,
                error: null,
            },
        };
    },
    [GET_CHANNELS_SUCCESS](
        state: ProgramsState,
        {
            payload: { channelsResponse },
        }: ReturnType<typeof getChannelsSuccess>,
    ): ProgramsState {
        return {
            ...state,
            channels: channelsResponse.services,
            getChannelsRequest: {
                ...state.getChannelsRequest,
                status: RequestStatus.SUCCESS,
                error: null,
            },
        };
    },
    [GET_CHANNELS_FAILURE](
        state: ProgramsState,
        { payload: { error } }: ReturnType<typeof getChannelsFailure>,
    ): ProgramsState {
        return {
            ...state,
            getChannelsRequest: {
                ...state.getChannelsRequest,
                status: RequestStatus.FAILURE,
                error,
            },
        };
    },

    [SET_NOW_NEXT_BY_CHANNEL_ID](
        state: ProgramsState,
        {
            payload: { nowNextResponse },
        }: ReturnType<typeof setNowNextByChannelId>,
    ): ProgramsState {
        return {
            ...state,
            nowNextByChannelId: {
                ...state.nowNextByChannelId,
                ...nowNextResponse.results.reduce((acc, nowNextItem) => {
                    return {
                        ...acc,
                        [nowNextItem.channelId]: nowNextItem.programmes,
                    };
                }, {}),
            },
        };
    },
};

export default { initialState: programsInitialState, handlers };
